window.mcb.forceMatchingWidths = (function () {
  // Private variables
  let resizeTimeout;
  const resizeMatchingWidthsObserver = new ResizeObserver(entries => {
    if (resizeTimeout) {
      clearTimeout(resizeTimeout);
    }

    resizeTimeout = setTimeout(() => {
      for (let entry of entries) {
        entry.target.querySelectorAll('.mcb-match-width').forEach((match) => {
          match.style.width = ''; // reset widths
        });

        let newWidth = 0;
        entry.target.querySelectorAll('.mcb-match-width').forEach((match) => {
          const rect = match.getBoundingClientRect();
          newWidth = Math.max(newWidth, rect.width);
        });

        if (newWidth > 0) {
          entry.target.querySelectorAll('.mcb-match-width').forEach((match) => {
            match.style.width = newWidth + 'px';
          });
        }
      }
    }, 10);
  });

  // Initialize matching widths
  let mcbMatchWidths = document.querySelectorAll('.mcb-match-widths:not(.mcb-page-header_ribbon--second)')
  mcbMatchWidths.forEach(element => {
    resizeMatchingWidthsObserver.observe(element);
  });

  // This module has no public interface
})();
